<script>
    import { onMount } from "svelte";
    import Conexoes from "../../Classes/Conexoes";
    import Constantes from "../../Classes/Constantes";
    import { DadosPlano, DadosLogin } from "../../Classes/Stores";
    import LoadingTela from "../../componentes_basicos/LoadingTela.svelte";
    import Navigate from "../../Classes/Navigate";
    const navi = new Navigate ();
    const conexao = new Conexoes();
    let api = Constantes.api_insere_pre_pagamento_plano;
    let isLoading = false;
    let id_usuario =  $DadosLogin.id_usuario;
    async function PrePaga() {
        let isLoading = true;
        if(!$DadosPlano || !$DadosPlano.id_plano || !$DadosPlano.pacote){
            navi.goTo(Constantes.tela_planos);
        }
        let parametros = $DadosPlano;
        parametros["id_usuario"] =id_usuario;

        let result = await conexao.conecta(api, parametros, true);
        if (result && result.sucesso && result.cod_inscricao_encurtado) {
            navi.goTo(Constantes.tela_pagamento+"?id="+result.cod_inscricao_encurtado);
        }
        isLoading = false;
    }
    onMount(()=>{PrePaga();});
</script>

<LoadingTela {isLoading} />
